import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import axiosInstance from "../utilites/axios";
import {endpoints} from "../endpoints/endpoints";

const fetchShippingData = async (query, startDate, endDate) => {
    try {
        const res = await axios.get(
            `https://www.listapp.info/admin/metrics/shipping.php?q=${query}&startDate=${startDate}&endDate=${endDate}`
        );
        if (res.status === 200) return res.data;
        throw new Error(`Unexpected response status: ${res.status}`);
    } catch (error) {
        console.error("Error fetching shipping data:", error);
        throw error;
    }
};

export const useGetShippingOrderList = ({query, startDate, endDate}) => {
    return useQuery({
            queryKey: ["shippingOrderList", query, startDate, endDate],
            queryFn: async () => fetchShippingData(query, startDate, endDate),
            staleTime: 0,
            cacheTime: 0,
            refetchInterval: 300000, // 5 minutes
        }
    )
};

export const useGetShippingDueList = ({query, startDate, endDate}) => {
    return useQuery({
            queryKey: ["shippingDueList", query, startDate, endDate],
            queryFn: async () => fetchShippingData(query, startDate, endDate),
            staleTime: 0,
            cacheTime: 0,
            refetchInterval: 300000,
        }
    )
};

export const useGetShippingPickedShelvingList = ({query, startDate, endDate}) => {
    return useQuery({
            queryKey: ["shippingPickedList", query, startDate, endDate],
            queryFn: async () => fetchShippingData(query, startDate, endDate),
            staleTime: 0,
            cacheTime: 0,
            refetchInterval: 300000,
        }
    )
};

export const useGetShippingEndingList = ({query, startDate, endDate}) => {
    return useQuery({
            queryKey: ["shippingEndingList", query, startDate, endDate],
            queryFn: async () => fetchShippingData(query, startDate, endDate),
            cacheTime: 0,
            refetchInterval: 300000,
        }
    )
};

export const useGetAllShippingList = ({limit, startDate, endDate}) => {
    return useQuery({
            queryKey: ["allShippingList", limit, startDate, endDate],
            queryFn: async () => {
                try {
                    const res = await axiosInstance.get(
                        `${endpoints.shipping}?limit=${limit ?? 111}&startDate=${startDate}&endDate=${endDate}`
                    );
                    if (res.status === 200) return res.data;
                    throw new Error(`Unexpected response status: ${res.status}`);
                } catch (error) {
                    console.error("Error fetching all shipping list:", error);
                    throw error;
                }
            },
            refetchInterval: 300000, // 5 seconds
        }
    )
};

export const useGetShippingDetails = ({uid, startDate, endDate}) => {
    return useQuery({
            queryKey: ["shippingDetails", uid, startDate, endDate],
            queryFn: async () => {
                if (!uid) throw new Error("UID is required");
                try {
                    const res = await axiosInstance.get(
                        `${endpoints.shipping}/details?uid=${uid}&startDate=${startDate}&endDate=${endDate}`
                    );
                    if (res.status === 200) return res.data;
                    throw new Error(`Unexpected response status: ${res.status}`);
                } catch (error) {
                    console.error("Error fetching shipping details:", error);
                    throw error;
                }
            },
            enabled: Boolean(uid),
            refetchInterval: 300000, // 5 seconds
        }
    )
};
